import { render, staticRenderFns } from "./JEditor.vue?vue&type=template&id=6e519810&scoped=true&"
import script from "./JEditor.vue?vue&type=script&lang=js&"
export * from "./JEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e519810",
  null
  
)

export default component.exports